import TextField from '@mui/material/TextField';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Link, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LoadingEllipsis from '../Ticket/Services/LoadingEllipsis';
import { styled } from '@mui/system';
import { getSapKeyUser, downloadAttachment, uploadAttachment, addComment } from '../../api/ticketsEndpoints';
import ErrorPopUp from '../ErrorPopUp/ErrorPopUp';
import EmojisNotAllowedMessage from '../Ticket/EmojisNotAllowedMessage';
import axiosInstance from '../../utils/axiosInstance';
import ErrorNetwork from '../ErrorPopUp/ErrorNetwork';
import BannerInfo from './BannerInfo';
import SingleComment from './SingleComment';
import ConfirmationModal from './ConfirmationModal';

const PREFIX = 'AddAttachments';
const classes = {
  boschIcon: `${PREFIX}-boschIcon`,
  crudAttachmentIcon: `${PREFIX}-crudAttachmentIcon`,
  crudAttachmentText: `${PREFIX}-crudAttachmentText`,
  removeAtachmentIcon: `${PREFIX}-removeAtachmentIcon`,
  addAttacmentsDisabled: `${PREFIX}-addAttacmentsDisabled`,
  addScreenshotContainer: `${PREFIX}-addScreenshotContainer`,
  paperClipIcon: `${PREFIX}-paperClipIcon`,
  addScreenshot: `${PREFIX}-addScreenshot`
};

const StyledCommentContainer = styled('div')({
  backgroundColor: 'whitesmoke',
  boxSizing: 'border-box',
  textAlign: 'center'
});

const StyledComment = styled(Grid)({
  content: '""',
  marginLeft: 'auto',
  marginRight: '0px',
  marginTop: '20px',
  marginBottom: '8px',
  backgroundColor: '#ffffff',
  border: 'solid 1px lightsteelblue',
  position: 'relative',
  width: 'auto',
  maxWidth: '90%',
  display: 'inline-block',
  float: 'right',
  padding: '10px',
  '&:before': {
    content: '""',
    width: '0px',
    height: '0px',
    borderLeft: '10px solid lightsteelblue',
    borderRight: '10px solid transparent',
    borderTop: '10px solid transparent',
    borderBottom: '10px solid transparent',
    display: 'block',
    position: 'absolute',
    left: '100%',
    top: '10px',
    zIndex: '1'
  },
  '&:after': {
    content: '""',
    width: '0px',
    height: '0px',
    borderLeft: '10px solid #ffffff',
    borderRight: '10px solid transparent',
    borderTop: '10px solid transparent',
    borderBottom: '10px solid transparent',
    display: 'block',
    position: 'absolute',
    left: 'calc(100% - 1px)',
    top: '10px',
    zIndex: '1'
  }
});

const StyledAgentComment = styled(Grid)({
  content: '""',
  marginRight: '0px',
  marginLeft: '-15px',
  marginTop: '20px',
  marginBottom: '8px',
  backgroundColor: '#ffffff',
  border: 'solid 1px lightsteelblue',
  position: 'relative',
  width: 'auto',
  maxWidth: '90%',
  display: 'inline-block',
  float: 'left',
  padding: '10px',
  '&:before': {
    content: '""',
    width: '0px',
    height: '0px',
    borderRight: '10px solid lightsteelblue',
    borderLeft: '10px solid transparent',
    borderTop: '10px solid transparent',
    borderBottom: '10px solid transparent',
    display: 'block',
    position: 'absolute',
    right: '100%',
    top: '10px',
    zIndex: '1'
  },
  '&:after': {
    content: '""',
    width: '0px',
    height: '0px',
    borderRight: '10px solid #ffffff',
    borderLeft: '10px solid transparent',
    borderTop: '10px solid transparent',
    borderBottom: '10px solid transparent',
    display: 'block',
    position: 'absolute',
    right: 'calc(100% - 1px)',
    top: '10px',
    zIndex: '1'
  }
});

const StyledCommentText = styled(Grid)({
  color: '#000000',
  fontSize: '14px',
  margin: 0,
  fontFamily: 'BoschSans-Light',
  marginTop: '10px',
  wordWrap: 'break-word'
});

const StyledDate = styled(Grid)({
  color: '#999999',
  fontSize: '12px',
  margin: 0,
  fontFamily: 'BoschSans-Regular'
});

const StyledIcon = styled('span')({
  fontFamily: 'bosch-icon',
  fontWeight: 400,
  fontSize: '28px',
  lineHeight: 1.6,
  color: '#004768',
  border: '1px solid #004768',
  borderRadius: '50%',
  backgroundColor: '#ffffff',
  maxHeight: '30px',
  position: 'relative',
  top: '25px',
  marginLeft: '25px',
  marginRight: '25px',
  float: 'left'
});

const StyledIconText = styled('label')({
  float: 'left',
  width: '100%',
  position: 'relative',
  top: '25px',
  left: '-10px'
});

const StyledThreeFilesMax = styled('p')({
  fontSize: '9px',
  color: '#8f8f8f'
});

const StyledInput = styled('input')({
  width: 0,
  height: 0,
  visibility: 'hidden',
  opacity: 0
});

const Comments = (props) => {
  const [commentsNumber, setCommentsNumber] = useState(0);
  const [isSapKeyUser, setIsSapKeyUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cpscCommentsArray, setCpscCommentsArray] = useState([]);
  const [attachmentsValue, handleAttachments] = useState([]);
  const [comment, setComment] = useState('');
  const [finalComments, setFinalComments] = useState([]);
  const [errorPopUp, setErrorPopUp] = useState(false);
  const [errorNetwork, setErrorNetwork] = useState(false);
  const [errorNetworkMessage, setErrorNetworkMessage] = useState({
    title: '',
    summary: ''
  });
  const [submitError, setSubmitError] = useState(null);
  const [isTicketSummWithEmojis, setIsTicketSummWithEmojis] = useState(false);
  const [downloadingId, setDownloadingId] = useState(null);
  const [addNewCommentSuccess, setAddNewCommentSuccess] = useState(false);
  const [addNewAttachmentSuccess, setAddNewAttachmentSuccess] = useState(false);
  // TEMPORARY SOLUTION: Using array of known SPEAR API usernames as fallback.
  // TODO: Remove this once REACT_APP_ITSMD_SPEAR_RESTAPI env var loads properly from OpenShift configmap.
  // This ensures comments showing as "You" vs "Agent" works across all environments (DEV/INT/QAS/PRD)
  // even if the env var is undefined.
  const spearRestApiNames = [
    process.env.REACT_APP_ITSMD_SPEAR_RESTAPI,
    'INT_Spear_DEV_restAPI',
    'INT_Spear_INT_restAPI',
    'INT_Spear_QAS_restAPI',
    'INT_Spear_PROD_restAPI'
  ].filter(Boolean);
  const { t } = useTranslation();
  let fileLoaderRef = React.createRef();

  let errorCommentsBody = t('ui_spear.errorComments.errorCommentsBody');
  let errorUploadAttachment = t('ui_spear.errorComments.errorUploadAttachment');
  let errorRetrievingComments = t('ui_spear.errorComments.errorRetrievingComments');
  let errorUploadComment = t('ui_spear.errorComments.errorUploadComment');

  useEffect(() => {
    validateSapKeyUser();
  }, [props.userInfo]);

  useEffect(() => {
    retrieveCpscComments();
  }, []);

  useEffect(() => {
    if ((props.source === 'smt' || props.source === 'ur') && props.TicketJourneyPage) {
      setLoading(true);
      // Helper function to safely check who the user is
      const determineUserLabel = (authorId) => {
        const authorStr = authorId || '';
        // 1. Is it the system API account?
        if (spearRestApiNames.includes(authorStr)) return 'You';

        // 2. Is it the logged-in user?
        const currentUserNTID = props.userInfo?.userNTID?.toUpperCase() || '';
        if (authorStr.toUpperCase() === currentUserNTID) return authorStr;

        // 3. If it's a support agent (or anyone else), label them as 'Agent'
        return 'Agent';
      };

      // 1. Map Comments (handles both 'comments' and 'journal' payloads)
      const rawComments = props.TicketJourneyPage.comments || props.TicketJourneyPage.journal || [];

      const ticketComments = rawComments.map(c => {
        const commentAuthor = c.author || c.sys_created_by;

        return {
          isAttachment: false,
          user: determineUserLabel(commentAuthor),
          date: c.createdDate || c.sys_created_on,
          text: c.text || c.value,
        };
      });

      // 2. Map Attachments (now enabled for BOTH 'smt' and 'ur')
      const rawAttachments = props.TicketJourneyPage.attachments || [];

      const ticketAttachments = rawAttachments.map(a => {
        const attachAuthor = a.author || a.sys_created_by;

        return {
          isAttachment: true,
          user: determineUserLabel(attachAuthor),
          date: a.createdDate || a.sys_created_on,
          fileName: a.fileName || a.file_name,
          sysId: a.id || a.sys_id,
        };
      });

      // 3. Combine and sort by date
      const combined = [...ticketComments, ...ticketAttachments];
      combined.sort((a, b) => new Date(a.date) - new Date(b.date));

      setFinalComments(combined);
      setCommentsNumber(combined.length);
      setLoading(false);
    }
  }, [props.TicketJourneyPage, props.source, props.userInfo]); // <-- Added props.userInfo to dependency array

  useEffect(() => {
    // This function will be called whenever the user selects files
    const uploadFiles = async () => {
      if (attachmentsValue.length === 0) {
        return;
      }
      setLoading(true);
      // Create an array of upload promises, one for each selected file
      const uploadPromises = attachmentsValue.map(attachment => {
        const { file, base64Data } = attachment;

        // Grab the 32-character sys_id for the payload
        const tableSysId = props.TicketJourneyPage.sys_id;
        // Grab the ticket number (e.g. "INC001" or "UR001") so the API can determine the table
        const ticketNumber = props.TicketJourneyPage.activity_id || props.TicketJourneyPage.number;

        // Call our function, passing the ticketNumber first (to calculate table), then sysId
        return uploadAttachment(ticketNumber, tableSysId, file.name, base64Data);
      });

      try {
        // Wait for all uploads to complete in parallel
        const results = await Promise.all(uploadPromises);

        // Check if any of the uploads failed (our function returns null on failure)
        const failedUploads = results.filter(result => result === null);

        if (failedUploads.length > 0) {
          throw new Error(`${failedUploads.length} out of ${attachmentsValue.length} files failed to upload.`);
        }
        setAddNewAttachmentSuccess(true);
      } catch (error) {
        console.error(error);
        setErrorNetworkMessage({
          title: 'File Upload Failed',
          summary: error.message || 'Please try again or contact IT support.'
        });
        showErrorNetworkPopUp();
      } finally {
        // This 'finally' block runs whether the upload succeeded or failed
        // Always clear the file input and stop the loading spinner
        handleAttachments([]);
        setLoading(false);
      }
    };

    // Trigger the upload process
    uploadFiles();
  }, [attachmentsValue]); // This hook still runs only when attachmentsValue chang

  const handleDownloadAttachment = async (sysId, fileName) => {
    if (downloadingId) return;
    setDownloadingId(sysId);

    try {
      const result = await downloadAttachment(sysId);

      // Check if we got a valid result object
      if (!result || result.status !== 'success' || !result.base64EncodedContent) {
        console.error("[Error] API response was successful but the 'result' object is malformed:", result);
        throw new Error(result?.message || 'Invalid data structure received from server.');
      }

      const { base64EncodedContent, content_type } = result;
      let blob;
      try {
        const byteCharacters = atob(base64EncodedContent);

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        blob = new Blob([byteArray], { type: content_type });
      } catch (decodingError) {
        console.error("Decoding Failed: The Base64 string is likely malformed.", decodingError);
        throw new Error("Failed to decode file content. The data may be corrupt.");
      }

      // Create a link and trigger the download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Attachment download process failed:", error);
      setErrorNetworkMessage({
        title: "Download Error",
        summary: error.message || "Could not process the file for download."
      });
      showErrorNetworkPopUp();
    } finally {
      setDownloadingId(null);
    }
  };

  const formatedDate = (originalDate, useFormat) => {
    var months = [
      t('ui_spear.myTickets.January'),
      t('ui_spear.myTickets.February'),
      t('ui_spear.myTickets.March'),
      t('ui_spear.myTickets.April'),
      t('ui_spear.myTickets.May'),
      t('ui_spear.myTickets.June'),
      t('ui_spear.myTickets.July'),
      t('ui_spear.myTickets.August'),
      t('ui_spear.myTickets.September'),
      t('ui_spear.myTickets.October'),
      t('ui_spear.myTickets.November'),
      t('ui_spear.myTickets.December')
    ];
    const date = new Date(originalDate);
    if (!isNaN(date.getDate())) {
      const day = date.getDate().toString();
      const month = months[date.getMonth()];
      let hours = date.getHours();
      let minutes = date.getMinutes();
      const ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
      const strTime = `${hours}:${minutes} ${ampm}`;
      const monthIndex = months.indexOf(month);
      if (!useFormat) {
        return `${date.getFullYear()}/${monthIndex + 1 < 10 ? '0' + (monthIndex + 1) : monthIndex + 1
          }/${day} ${strTime}`;
      } else {
        return `${date.getFullYear()}/${month}/${day} ${strTime}`;
      }
    }
  };

  const retrieveCpscComments = async () => {
    if (props.source === 'old') {
      const getCommentsURL = `/api/v1/cpsc/tickets/comments/${props.TicketJourneyPage.activity_id}`;
      let cpscComments = [];
      setLoading(true);
      try {
        const response = await axiosInstance.get(getCommentsURL);
        setLoading(false);
        if (response.status === 200) {
          if (response.data.isSuccessful) {
            response.data.data.map((commentObject) => {
              let userName =
                commentObject.FirstName + ' ' + commentObject.LastName;
              let dateValue =
                commentObject.CommentedOn.split('T')[0] +
                ' ' +
                commentObject.CommentedOn.split('T')[1].substring(0, 8);
              cpscComments.push({
                user: userName,
                date: dateValue,
                text: commentObject.CommentText
              });
            });
            setCpscCommentsArray(cpscComments);
          }
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
        setErrorNetworkMessage({
          title: errorUploadComment,
          summary: errorCommentsBody
        });
        showErrorNetworkPopUp();
      }
    }
  };

  const validateEmojisInputs = (value) => {
    const emojiRegex =
      /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u26FF\u2700-\u27BF]/;
    if (emojiRegex.test(value)) {
      setIsTicketSummWithEmojis(true);
      return false;
    } else {
      setIsTicketSummWithEmojis(false);
      return true;
    }
  };

  const addNewComment = async () => {
    const formatedComment = comment;

    // Removed the emoji validation check here
    if (formatedComment.trim() === '' || !validateEmojisInputs(formatedComment)) {
      return;
    }

    setLoading(true);
    try {
      const incidentNumber = props.TicketJourneyPage.activity_id;
      const result = await addComment(incidentNumber, formatedComment);

      if (result) {
        setComment('');
        setAddNewCommentSuccess(true);
      } else {
        throw new Error('Failed to add comment. The server returned a non-success status.');
      }
    } catch (error) {
      console.error(error);
      setErrorNetworkMessage({
        title: 'Could Not Add Comment',
        summary: error.message || 'An error occurred. Please try again.'
      });
      showErrorNetworkPopUp();
    } finally {
      setLoading(false);
    }
  };


  const handleCloseCommentSuccessModal = () => {
    setAddNewCommentSuccess(false);
    window.location.reload();
  };

  const handleCloseAttachmentSuccessModal = () => {
    setAddNewAttachmentSuccess(false);
    window.location.reload();
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const getEncodedData = (fullBase64) => {
    const splittedData = fullBase64.split(',');
    if (splittedData[1]) {
      return splittedData[1];
    }
    return null;
  };

  const handleLoadAttachment = async (event) => {
    setLoading(true);
    if (event.target.files.length <= 3) {
      let attachmentsArray = [];
      await Promise.all(
        Array.from(event.target.files).map(async (file) => {
          if (file.size <= 5000000) {
            const url = window.URL.createObjectURL(file);
            const fullBase64 = await toBase64(file);
            const base64Data = getEncodedData(fullBase64);
            const newFile = {
              downloadUrl: url,
              file: file,
              fullBase64: fullBase64,
              base64Data: base64Data
            };
            attachmentsArray.push(newFile);
          } else {
            handleAttachments([]);
            showErrorPopUp();
          }
        })
      );
      handleAttachments(attachmentsArray);
    } else {
      handleAttachments([]);
      showErrorPopUp();
    }
  };

  const showErrorPopUp = () => {
    setLoading(false);
    setErrorPopUp(!errorPopUp);
  };

  const showErrorNetworkPopUp = () => {
    setLoading(false);
    setErrorNetwork(!errorNetwork);
  };

  const handleComment = (event) => {
    setComment(event.target.value);
  };

  const dataURLtoFile = (base64, filename, mime) => {
    var bstr = atob(base64);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const validateSapKeyUser = async () => {
    try {
      const sapKeyUser = await getSapKeyUser(props?.userInfo?.userNTID);
      setIsSapKeyUser(sapKeyUser?.data?.json);
    } catch (error) {
      console.log('Error while verifiying SAP KEY USER', error);
      setIsSapKeyUser(false);
    }
  };

  const commentsSection = () => {
    const fullName =
      props?.userInfo?.userGivenName + ' ' + props?.userInfo?.userFamilyName;
    if (props.source === 'old' || props.source === 'new') {
      // ... (this section remains unchanged)
      if (
        props?.TicketJourneyPage?.status == 'Completed' ||
        props?.TicketJourneyPage?.status == 'Rejected' ||
        props?.TicketJourneyPage?.status == 'Cancelled'
      ) {
        return (
          <>
            <h2 className="py-10 w-4/6 mx-auto text-3xl font-Bosch_sans_light">
              {t('ui_spear.ticketDetails.Comments.title')}
            </h2>
            {props.source === 'new' &&
              props.TicketJourneyPage?.comments.length > 0 &&
              props?.TicketJourneyPage?.status === 'Rejected' && (
                <div className="w-4/6 mx-auto p-4 gap-4 items-center mb-4">
                  {props.TicketJourneyPage.comments.map(
                    (commentString, index) => {
                      let dateUser = commentString.split('(Comments)')[0];
                      let dateValue = dateUser.split(' - ')[0] || '';
                      let userValue = dateUser.split(' - ')[1] || '';
                      let commentValue =
                        commentString.split('(Comments)')[1] || '';
                      let commentObject = {
                        user: userValue,
                        date: dateValue,
                        text: commentValue
                      };
                      return (
                        <SingleComment comment={commentObject} key={index} />
                      );
                    }
                  )}
                </div>
              )}
            {props.source === 'old' &&
              cpscCommentsArray.length > 0 &&
              props?.TicketJourneyPage?.status === 'Rejected' && (
                <div className="w-4/6 mx-auto p-4 gap-4 items-center mb-4">
                  {cpscCommentsArray.map((comment, index) => (
                    <SingleComment comment={comment} key={index} />
                  ))}
                </div>
              )}
            <div className="py-10 w-4/6 flex mx-auto gap-4 bg-slate-200 p-4 items-center">
              <span
                className={`boschicon-bosch-ic-settings-arrows text-[28px]`}
              ></span>
              <div className="flex flex-col">
                <p>
                  {t('ui_spear.ticketDetails.Comments.Your_request')}
                  <span className="font-bold">
                    {' '}
                    {t('ui_spear.ticketDetails.Comments.automated system')}{' '}
                    {t('ui_spear.ticketDetails.Comments.it_wont')}{' '}
                  </span>
                </p>
                <p>
                  {t('ui_spear.ticketDetails.Comments.If_you_experience')}{' '}
                  {props.isSupportEntitle ? (
                    <Link
                      href={`${process.env.REACT_APP_UI_URL}/support/ticket`}
                      className="hover:cursor-pointer"
                    >
                      {t('ui_spear.ticketDetails.Comments.create_a_ticket')}
                    </Link>
                  ) : (
                    t('ui_spear.ticketDetails.Comments.create_a_ticket')
                  )}{' '}
                  {t('ui_spear.ticketDetails.Comments.or')}{' '}
                  {t('ui_spear.ticketDetails.Comments.Contact_us')}.{' '}
                  {t('ui_spear.ticketDetails.Comments.Then_we_will')}
                </p>
              </div>
            </div>
          </>
        );
      } else if (props?.TicketJourneyPage?.status == 'In approval') {
        return (
          <>
            <h2 className="py-10 w-4/6 mx-auto text-3xl font-Bosch_sans_light">
              {t('ui_spear.ticketDetails.Comments.title')}
            </h2>
            <div className="py-10 w-4/6 flex mx-auto gap-4 bg-slate-200 p-4 gap-4 items-center">
              <span
                className={`boschicon-bosch-ic-settings-arrows text-[28px]`}
              ></span>
              <div className="flex flex-col">
                <p>
                  {t('ui_spear.ticketDetails.Comments.After_approval')}
                  <span className="font-bold">
                    {' '}
                    {t('ui_spear.ticketDetails.Comments.automated system')}{' '}
                    {t('ui_spear.ticketDetails.Comments.it_wont')}{' '}
                  </span>
                </p>
                <p>
                  {t('ui_spear.ticketDetails.Comments.If_you_experience')}{' '}
                  {props.isSupportEntitle ? (
                    <Link
                      href={`${process.env.REACT_APP_UI_URL}/support/ticket`}
                      className="hover:cursor-pointer"
                    >
                      {t('ui_spear.ticketDetails.Comments.create_a_ticket')}
                    </Link>
                  ) : (
                    t('ui_spear.ticketDetails.Comments.create_a_ticket')
                  )}{' '}
                  {t('ui_spear.ticketDetails.Comments.or')}{' '}
                  {t('ui_spear.ticketDetails.Comments.Contact_us')}.{' '}
                  {t('ui_spear.ticketDetails.Comments.Then_we_will')}
                </p>
              </div>
            </div>
          </>
        );
      } else if (props?.TicketJourneyPage?.status == 'In progress') {
        return (
          <>
            <h2 className="py-10 w-4/6 mx-auto text-3xl font-Bosch_sans_light">
              {t('ui_spear.ticketDetails.Comments.title')}
            </h2>
            <div className="py-10 w-4/6 flex mx-auto gap-4 bg-slate-200 p-4 gap-4 items-center">
              <span
                className={`boschicon-bosch-ic-settings-arrows text-[28px]`}
              ></span>
              <div className="flex flex-col">
                <p>
                  {t('ui_spear.ticketDetails.Comments.Your_request_being')}
                  <span className="font-bold">
                    {' '}
                    {t('ui_spear.ticketDetails.Comments.automated system')}{' '}
                    {t('ui_spear.ticketDetails.Comments.it_wont')}{' '}
                  </span>
                </p>
                <p>
                  {t('ui_spear.ticketDetails.Comments.If_you_experience')}{' '}
                  {props.isSupportEntitle ? (
                    <Link
                      href={`${process.env.REACT_APP_UI_URL}/support/ticket`}
                      className="hover:cursor-pointer"
                    >
                      {t('ui_spear.ticketDetails.Comments.create_a_ticket')}
                    </Link>
                  ) : (
                    t('ui_spear.ticketDetails.Comments.create_a_ticket')
                  )}{' '}
                  {t('ui_spear.ticketDetails.Comments.or')}{' '}
                  {t('ui_spear.ticketDetails.Comments.Contact_us')}.{' '}
                  {t('ui_spear.ticketDetails.Comments.Then_we_will')}
                </p>
              </div>
            </div>
          </>
        );
      } else {
        return (
          <>
            <h2 className="py-10 w-4/6 mx-auto text-3xl font-Bosch_sans_light">
              {t('ui_spear.ticketDetails.Comments.title')}
            </h2>
            <div className="py-10 w-4/6 flex mx-auto gap-4 bg-slate-200 p-4 gap-4 items-center">
              <span
                className={`boschicon-bosch-ic-settings-arrows text-[28px]`}
              ></span>
              <div className="flex flex-col">
                <p>
                  {t('ui_spear.ticketDetails.Comments.RequestProcessed')}
                  <span className="font-bold">
                    {t('ui_spear.ticketDetails.Comments.automated system')}{' '}
                    {t('ui_spear.ticketDetails.Comments.it_wont')}
                  </span>
                </p>
                <p>
                  {t('ui_spear.ticketDetails.Comments.If_you_experience')}{' '}
                  {props.isSupportEntitle ? (
                    <Link
                      href={`${process.env.REACT_APP_UI_URL}/cisco/tickets`}
                      className="hover:cursor-pointer"
                    >
                      {t('ui_spear.ticketDetails.Comments.create_a_ticket')}
                    </Link>
                  ) : (
                    t('ui_spear.ticketDetails.Comments.create_a_ticket')
                  )}
                  . {t('ui_spear.ticketDetails.Comments.Then_we_will')}
                </p>
              </div>
            </div>
          </>
        );
      }
    } else if (
      props?.userInfo?.userNTID.toUpperCase() ===
      props?.TicketJourneyPage?.performer?.toUpperCase() ||
      props?.userInfo?.userNTID.toUpperCase() ===
      props?.TicketJourneyPage?.requested_for?.toUpperCase()
    ) {
      const isCommentingAllowed = !['Resolved', 'Closed', 'Cancelled', 'Canceled'].includes(props?.TicketJourneyPage?.status);
      return (
        <div className="py-10 w-4/6 flex flex-col mx-auto gap-4">
          <h2 className="text-3xl">
            {t('ui_spear.ticketDetails.Comments.title')}({commentsNumber})
          </h2>
          <div className="flex flex-inline">
            <p className="font-semibold">
              {(isCommentingAllowed ? t('ui_spear.ticketDetails.Comments.AnyUpdates') : t('ui_spear.ticketDetails.You_cannot_add_comments'))}
            </p>
            {isCommentingAllowed &&
              <BannerInfo
                messageString={t(
                  'ui_spear.createTicket.allowedAttachmentsTitleV2'
                )}
              />}
          </div>
          {loading && <LoadingEllipsis></LoadingEllipsis>}
          {commentsNumber > 0 ? (
            <Grid
              style={{
                maxHeight: '250px',
                overflowY: 'scroll',
                overflowX: 'hidden'
              }}
            >
              {finalComments.map((comment, index) => {
                const isOwnComment = comment.user === "You" || comment.user.toUpperCase() === props.userInfo.userNTID.toUpperCase();
                const CommentBubble = isOwnComment ? StyledComment : StyledAgentComment;

                const commentBubbleContent = (
                  <CommentBubble>
                    <StyledDate>
                      {formatedDate(comment.date, true)}
                    </StyledDate>
                    {comment.isAttachment ? (
                      <StyledCommentText>
                        <span className="boschicon-bosch">&#xe1a2;</span>
                        {downloadingId === comment.sysId ? (
                          <span style={{ paddingLeft: '5px', color: '#999' }}>Downloading...</span>
                        ) : (
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleDownloadAttachment(comment.sysId, comment.fileName);
                            }}
                            style={{ cursor: 'pointer', color: '#005691', textDecoration: 'underline', paddingLeft: '5px' }}
                          >
                            {comment.fileName}
                          </a>
                        )}
                      </StyledCommentText>
                    ) : (
                      <StyledCommentText>
                        {comment.text}
                      </StyledCommentText>
                    )}
                  </CommentBubble>
                );

                const userIconContent = (
                  <Grid>
                    <StyledIcon className="boschicon-bosch-ic-user"></StyledIcon>
                    <StyledIconText style={{ left: isOwnComment ? '-10px' : '-17px' }}>
                      {isOwnComment ? t('ui_spear.myTickets.You') : comment.user}
                    </StyledIconText>
                  </Grid>
                );

                return (
                  <Fragment key={index}>
                    <StyledCommentContainer>
                      <Grid container>
                        {isOwnComment ? (
                          <>
                            {commentBubbleContent}
                            {userIconContent}
                          </>
                        ) : (
                          <>
                            {userIconContent}
                            {commentBubbleContent}
                          </>
                        )}
                      </Grid>
                    </StyledCommentContainer>
                  </Fragment>
                );
              })}
            </Grid>
          ) : (
            <Grid></Grid>
          )}

          <div>
            {isTicketSummWithEmojis ? <EmojisNotAllowedMessage /> : null}
          </div>
          {isCommentingAllowed &&
            <TextField
              inputProps={{ maxLength: 10000 }}
              value={comment}
              onChange={(event) => handleComment(event)}
              placeholder={t('ui_spear.ticketDetails.Comments.TypeYourcomments')}
              label={t('ui_spear.ticketDetails.Comments.TypeYourcomments')}
              variant="outlined"
            />}
          {isCommentingAllowed &&
            <div className="flex justify-end gap-2">
              <div
                className="flex items-center gap-3"
                style={{ position: 'relative', left: '-20px' }}
              >
                <span
                  className={`boschicon-bosch-ic-paperclip text-blue-500 hover:text-blue-400 hover:cursor-pointer text-[22px] font-base`}
                ></span>
                <div className="flex flex-col">
                  <label
                    htmlFor={`load-attachments-input`}
                    className={
                      attachmentsValue.length === 3 ?
                        classes.addAttacmentsDisabled :
                        ''
                    }
                  >
                    <div className={classes.addScreenshotContainer}>
                      <span
                        style={{ color: '#005691', cursor: 'pointer' }}
                        className={classes.addScreenshot}
                      >
                        {t('ui_spear.createTicket.Add_attachment')}
                      </span>
                    </div>
                  </label>
                  <StyledInput
                    type="file"
                    id={`load-attachments-input`}
                    accept="*"
                    multiple
                    disabled={attachmentsValue.length === 3}
                    onChange={handleLoadAttachment}
                    ref={fileLoaderRef}
                  ></StyledInput>
                  <StyledThreeFilesMax>
                    {t('ui_spear.ticketDetails.Comments.MaxFiles')}
                  </StyledThreeFilesMax>
                </div>
              </div>
              <Button
                style={{ position: 'relative', left: '-20px' }}
                onClick={() => addNewComment()}
                className="save-document"
                disabled={loading}
              >
                {loading ? 'Adding...' : t('ui_spear.ticketDetails.Comments.AddComment')}
              </Button>
            </div>}
        </div>
      )
    } else if (
      fullName == props.TicketJourneyPage.requested_for &&
      props.source == 'new'
    ) {
      return (
        <>
          <h2 className="py-10 w-4/6 mx-auto text-3xl font-Bosch_sans_light">
            {t('ui_spear.ticketDetails.Comments.title')}
          </h2>
          <div className="py-10 w-4/6 flex mx-auto gap-4 bg-slate-200 p-4 gap-4 items-center">
            <span
              className={`boschicon-bosch-ic-settings-arrows text-[28px]`}
            ></span>
            <div className="flex flex-col">
              <p>
                {t('ui_spear.ticketDetails.Comments.RequestProcessed')}
                <span className="font-bold">
                  {t('ui_spear.ticketDetails.Comments.automated system')}.{' '}
                  {t('ui_spear.ticketDetails.Comments.it_wont')}
                </span>
              </p>
              <p>
                {t('ui_spear.ticketDetails.Comments.If_you_experience')}{' '}
                {props.isSupportEntitle ? (
                  <Link
                    href={`${process.env.REACT_APP_UI_URL}/cisco/tickets`}
                    className="hover:cursor-pointer"
                  >
                    {t('ui_spear.ticketDetails.Comments.create_a_ticket')}
                  </Link>
                ) : (
                  t('ui_spear.ticketDetails.Comments.create_a_ticket')
                )}
                . {t('ui_spear.ticketDetails.Comments.Then_we_will')}
              </p>
            </div>
          </div>
        </>
      );
    } else {
      return '';
    }
  };

  return (
    <>
      {commentsSection()}
      {errorPopUp ? (
        <ErrorPopUp
          errorPopUp={errorPopUp}
          errorMessage={''}
          togglePopUp={showErrorPopUp}
          submitError={submitError}
        ></ErrorPopUp>
      ) : (
        ''
      )}
      {errorNetwork ? (
        <ErrorNetwork
          errorPopUp={errorNetwork}
          errorText={errorNetworkMessage}
          togglePopUp={showErrorNetworkPopUp}
        />
      ) : null}

      {/* Our new Confirmation Modal */}
      <ConfirmationModal
        open={addNewCommentSuccess}
        onClose={handleCloseCommentSuccessModal}
        title="Comment Added"
        message="Your comment has been successfully added to the ticket."
      />

      {/* Merge with Worknote One */}
      <ConfirmationModal
        open={addNewAttachmentSuccess}
        onClose={handleCloseAttachmentSuccessModal}
        title="Attachment Added"
        message="Your attachment has been successfully added to the ticket."
      />
    </>
  );
};

export default Comments;
